import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "cameligo",
  extensions: [".mligo"],
  aliases: ["Cameligo"],
  loader: () => import('./cameligo.js')
});
